import MyDataPage from './MyDataPage'

export default MyDataPage
